import { Divider } from '@mui/material'
import VersionInfo from 'components/VersionInfo/VersionInfo'
import { useUser } from 'hooks/user'
import i18next, { changeLanguage } from 'i18next'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { LANGUAGES } from 'utils/constants'
import getTestId from 'utils/getTestId'

import style from './UserMenu.module.css'

const UserMenu = React.forwardRef<HTMLDivElement | null>((props, ref) => {
  const { t } = useTranslation()
  const user = useUser()

  const onLogoutClick = useCallback(() => {
    user?.actions.signout()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onLanguageClick = useCallback(() => {
    console.log(i18next.languages)
    if (i18next.languages[0] === 'ru') {
      changeLanguage(LANGUAGES.EN)
    } else {
      changeLanguage(LANGUAGES.RU)
    }
  }, [])

  return (
    <div ref={ref} className={style.menu}>
      {/* <div
        className={style.item}
        onClick={() => {
          console.log('Settings')
        }}
        data-test-id={getTestId('userMenuSetting')}
      >
        {t('header.profile')}
      </div> */}
      <div className={style.item} onClick={onLanguageClick} data-test-id={getTestId('userMenuLanguage')}>
        {t('header.language')}
      </div>
      <div className={style.item} onClick={onLogoutClick} data-test-id={getTestId('userMenuLogout')}>
        {t('header.logout')}
      </div>
      <Divider />
      <VersionInfo direction="column" />
    </div>
  )
})

export default UserMenu
